import { ROUTES_URL } from 'src/constants/routes';

import useGoTo from 'src/hooks/useGoTo';

import DescribeYourBusinessScreen from '../DescribeYourBusiness';

export default function DescribeYourBusiness() {
    const goTo = useGoTo();

    const onSuccessHandler = () => {
        // Бэкенд уже обновил шаг на 'choose_stream' при сохранении description
        // Переходим на страницу запуска сервиса /leadstream
        goTo(ROUTES_URL.LEADSTREAM);
    };

    return <DescribeYourBusinessScreen onSuccess={onSuccessHandler} />;
}
